
import { ListRelatedContentsContentTypesEnum } from '@rtl/api'
import { mixins, Options, Watch } from 'vue-property-decorator'
import { Action } from 'vuex-class'

import { CONTENT_ACTION, CONTENT_NAMESPACE, ContentListResult, ContentRelatedListPayload } from '../../store'
import Close from '../components/icons/Close.vue'
import Play from '../components/icons/Play.vue'
import Image from '../components/Image.vue'
import NavLink from '../components/NavLink.vue'
import { GetPageMixin } from '../mixins'
import WidgetMixin from './WidgetMixin'

@Options({
  name: 'RecommendedPipVideoWidget',
  components: {
    Close,
    Play,
    Image,
    NavLink
  }
})
export default class RecommendedPipVideoWidget extends mixins(GetPageMixin, WidgetMixin) {
  @Action(CONTENT_ACTION.RELATED, { namespace: CONTENT_NAMESPACE })
  storeFetchContentRelatedList!: (payload: ContentRelatedListPayload) => Promise<ContentListResult>

  show = true

  close () {
    this.measure('close')
    this.show = false
  }

  get content (): ContentListResult['data'][0] | null {
    if (this.contentRelatedListPayload) {
      return this.$store.getters['$cache/result']([CONTENT_NAMESPACE, CONTENT_ACTION.RELATED], this.contentRelatedListPayload)?.data.items[0] || null
    }
    return null
  }

  get contentRelatedListPayload (): ContentRelatedListPayload | null {
    const contentId = this.page?.contentId
    return contentId
      ? {
          contentTypes: [ListRelatedContentsContentTypesEnum.News],
          contentId,
          nsfwContent: this.page?.trackingVariables?.nsfwFlag ? undefined : 0,
          withVideo: 1,
          limit: 1
        }
      : null
  }

  @Watch('contentRelatedListPayload', { deep: true })
  async fetchContentRelatedList () {
    if (this.contentRelatedListPayload) {
      return this.storeFetchContentRelatedList(this.contentRelatedListPayload)
    }
  }

  @Watch('content')
  onContentChange () {
    if (this.show && this.content) {
      this.measure('view')
    }
  }

  measure (action: string) {
    if (this.$gtm && this.$gtm.enabled()) {
      this.$gtm.trackEvent({
        event: 'interaction',
        event_name: `${action}_recommendation`,
        recommendation_name: this.content?.id,
        referral_name: this.page?.contentId
      })
    }
  }

  serverPrefetch () {
    return this.fetchContentRelatedList()
  }

  mounted () {
    return this.fetchContentRelatedList()
  }
}
